import { MessageSquare, Download, XCircle, FileText, Zap } from "lucide-react";
import { Button } from "@shared/ui/button";
import { Card, CardContent } from "@shared/ui/card";

interface QuickActionsProps {
  consumerCount: number;
  onNotify: () => void;
  onExport: () => void;
  onReject: () => void;
  onDownloadBills: () => void;
  isBillsGenerated?: boolean;
  currentStatus?: string;
  isRejecting?: boolean;
  isExporting?: boolean;
  isDownloadingBills?: boolean;
}

export const QuickActions = ({
  consumerCount,
  onNotify,
  onExport,
  onReject,
  onDownloadBills,
  isBillsGenerated = false,
  currentStatus,
  isRejecting = false,
  isExporting = false,
  isDownloadingBills = false,
}: QuickActionsProps) => {
  const isAcknowledgeStatus = currentStatus?.toLowerCase() === "acknowledged";
  const billGenerationInProgress =
    currentStatus?.toLowerCase() === "bill generation in progress";

  return (
    <Card className="border shadow-sm bg-white p-4 h-full">
      <div className="flex items-center gap-2 mb-6">
        <Zap className="h-5 w-5" />
        <h3 className="font-semibold text-lg">Quick Actions</h3>
      </div>
      <div className="space-y-4">
        <Button
          variant="secondary"
          className="w-full justify-start gap-3 bg-blue-100 text-blue-900 hover:bg-blue-200 border-none h-10"
          onClick={onNotify}
        >
          <MessageSquare className="h-5 w-5" />
          <span className="font-medium">Notify {consumerCount} consumers</span>
        </Button>

        <Button
          variant="outline"
          className="w-full justify-start gap-3 h-10 text-gray-700 border-gray-200"
          onClick={onExport}
          disabled={isExporting}
        >
          <Download className="h-5 w-5" />
          <span className="font-medium">
            {isExporting ? "Exporting..." : "Export consumer list"}
          </span>
        </Button>

        <Button
          variant="outline"
          className="w-full justify-start gap-3 h-10 text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700 hover:border-red-300"
          onClick={onReject}
          disabled={!isAcknowledgeStatus || isRejecting}
        >
          <XCircle className="h-5 w-5" />
          <span className="font-medium">
            {isRejecting ? "Rejecting..." : "Reject request"}
          </span>
        </Button>

        <Button
          variant="outline"
          className={
            billGenerationInProgress
              ? "w-full justify-start gap-3 h-10 text-gray-700 border-gray-200"
              : "w-full justify-start gap-3 h-10 bg-gray-100 text-gray-400 border-none cursor-not-allowed opacity-70"
          }
          onClick={onDownloadBills}
          disabled={!billGenerationInProgress || isDownloadingBills}
        >
          <FileText className="h-5 w-5" />
          <span className="font-medium">
            {isDownloadingBills ? "Downloading..." : "Download all Bills"}
          </span>
        </Button>
      </div>
    </Card>
  );
};
